module.exports = __webpack_public_path__ + "static/media/rss-rss-icon-svgrepo-com.8985f5a6.svg";